module.exports = __webpack_public_path__ + "fonts/Inter-Regular.3ac8302.woff";